import {Component, EventEmitter,OnChanges, OnInit,Input,Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from '../../services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ara-report-log',
  templateUrl: './report-log.component.html',
  styleUrls: ['./report-log.component.css']
})
export class ReportLogComponent implements OnInit {
    @Input() ReportUserId: any;
    @Input() ReportModule: any;
    @Input() ReportRecordId: any;
    ReportLogData:any;
  constructor(private translate: TranslateService, private baseService: BaseService,private commonservice : CommonService) {
   
  }

  ngOnInit() 
  {
    const apiRequest = {
        Model: {
          "ReportUserId": this.ReportUserId,
          "ReportModule": this.ReportModule,
          "ReportRecordId":this.ReportRecordId
        
       }
      };
  
      this.commonservice.getReportLog(apiRequest,this.callbackMethodForgetReportLog.bind(this));  
  }

  callbackMethodForgetReportLog(response){
    if(response.Success)
    this.ReportLogData = response.Result;
  }

}